import axios from "axios";

export async function injectSpritesheet(uri) {
  const response = await axios(uri);
  const container = document.createElement("div");
  container.innerHTML = response.data;
  const sprite = container.firstChild;

  if (sprite) document.body.insertBefore(sprite.cloneNode(true), document.body.firstChild);
}

export const generateID = (prefix = "id") =>
  `${prefix}-${(Math.random() * Date.now())
    .toString()
    .replace(".", "")
    .substr(-8)}`;



// WEBPACK FOOTER //
// ./src/helpers/uiHelpers.js